import View from './MembersSidesheet';
import enhancer from './MembersSidesheet.enhancer';

export default enhancer(View);
